import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";

import "./SummaryChartCard.css";

/**
 * @function summaryChartCard
 * @param {Object} props
 * @param {number} props.productivityRate - tracked/productive time value
 * @param {number} props.Idle - idle time value
 * @param {number} props.Manual - manual time value
 * @param {number} props.Overtime - overtime value
 * @param {number} props.Total - total tracked time
 */
function SummaryChartCard(props) {
  const [isSummaryEmpty, setIsSummaryEmpty] = useState(true)

  function checkInputsValues(summary){
    if(summary.Idle === 0 && summary.Manual === 0 && summary.Productive === 0 && summary.Total === 0) setIsSummaryEmpty(true)
      else setIsSummaryEmpty(false)
  }
  
  const isEmpty = isSummaryEmpty;

  const chartdata = {
    labels: ["Tracked Time", "Idle Time", "Manual Time", "Overtime", "Marked Time"],
    datasets: [
      {
        data: isEmpty
          ? [1, 1, 1, 1]
          : [props.productivityRate, props.Idle, props.Manual, props.Overtime],
        backgroundColor: isEmpty
          ? ["#E5E7EB", "#E5E7EB", "#E5E7EB", "#E5E7EB", "#E5E7EB"] 
          : ["#22C55E", "#B0BEC5", "#609AF8", "#EAB308", "#ea5b08"],
        borderColor: isEmpty
          ? ["#E5E7EB", "#E5E7EB", "#E5E7EB", "#E5E7EB", "#E5E7EB"]
          : ["#22C55E", "#B0BEC5", "#609AF8", "#EAB308", "#ea5b08"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    cutout: '70%',
    plugins: {
      legend: {
        position: 'right',
        align: 'center',
        labels: {
          usePointStyle: true,
          boxWidth: 10,
          padding: 15
        }
      }
    }
  };

  useEffect(() => {
    checkInputsValues(props)
  }, [props])

  return (
    <div className="my-summary-productivity-chart-container">
      <div className="chart-wrapper">
        <Chart type="doughnut" data={chartdata} options={options} />
      </div>
    </div>
  );
}

export default SummaryChartCard;
